export default async function login({ next, store }) {
  const isUserLoggedIn = await store.dispatch('auth/isUserLoggedIn')
  if (isUserLoggedIn) {
    return next({ name: store.getters['auth/getHomeRoute'] })
  }

  return next()
}
